import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./iohPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"
import { drawGrandTotal } from "./iohdrawGrandTotalpdf";
//import { drawWatermark  } from "../../../component/watermark";
export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);


  //console.log("Grouped Data:", grouped);
  let firstPage = true;

//drawWatermark (doc);

  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



drawGrandTotal(doc, grandTotal);
  

  drawFooter(doc, month, year, title);

 handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.rail ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          nooftrolly: 0,
          coachset: 0,
          labourcost: 0,
          materialcost: 0,
          totalcost: 0,
        },
      };
    }

    groups[shop].rows.push(row);

    groups[shop].total.nooftrolly += Number(row.nooftrolly || 0);
    groups[shop].total.coachset += Number(row.coachset || 0);
    groups[shop].total.labourcost += Number(row.labourcost || 0);
    groups[shop].total.materialcost += Number(row.materialcost || 0);
    groups[shop].total.totalcost += Number(row.totalcost || 0);
    

    return groups;
  }, {});
}